<template>
  <Card>
    <p slot="title"><Icon type="android-add-circle"></Icon> 发送消息</p>
    <div>
      <Form ref="form" :model="model" :rules="ruleValidate" :label-width="120">
        <Form-item prop="title" label="标题">
          <Input type="text" v-model="model.title" placeholder="请输入标题">
          </Input>
        </Form-item>
        <Form-item prop="receivers" label="收信人">
          <Select v-model="model.receivers" filterable multiple>
            <Option v-for="(user, key) in users" :value="user.id" :key="key">
              {{ user.name + '(' + user.email + ')'}}
            </Option>
          </Select>
        </Form-item>
        <Form-item prop="content" label="正文">
          <vue-editor v-model="model.content" class="post-editor" :editorToolbar="customToolbar"></vue-editor>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="handleSubmit('form')" long >保存</Button>
        </Form-item>
      </Form>
    </div>
  </Card>
</template>

<script>
import { CreateMessage, GetAssistItems } from '@/api/message'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'add-message',
  data: function () {
    return {
      model: {
        title: '',
        content: '',
        receivers: []
      },
      users: {},
      ruleValidate: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '正文不能为空', trigger: 'change' }
        ],
        receivers: [
          { required: true, type: 'array', message: '接收者不能为空', trigger: 'change' }
        ]
      },
      customToolbar: [
        ['bold', 'italic', 'underline'],
        ['blockquote', 'code-block'],
        [{
          'list': 'ordered'
        }, {
          'list': 'bullet'
        }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['image', 'code-block']
      ]
    }
  },
  components: {
    VueEditor
  },
  created: function () {
    GetAssistItems().then(async res => {
      this.users = res.users
    })
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateMessage(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        }
        if (res.id) {
          this.model.title = ''
          this.model.content = ''
          this.model.receivers = []
          this.$Message.success('发送成功')
          this.$store.commit('refresh')
          this.$emit('changeView', 'sent')
        }
      })
    }
  }
}
</script>
